import { fetchAssetCatalog } from '@/features/assets/api/assets';
import {
  ASSETS_KEY,
  ASSETS_STALE_TIME,
  ASSET_CATALOG_PAGE_SIZE,
} from '@/features/assets/config/constants';
import { serializeAssetCatalogFilters } from '@/features/assets/lib/assetCatalog';
import type { AssetCatalogFilters } from '@/features/assets/types/asset';
import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

export function assetCatalogQuery(filters: AssetCatalogFilters = {}) {
  const serializedFilters = serializeAssetCatalogFilters(filters);
  return infiniteQueryOptions({
    queryKey: [ASSETS_KEY, 'asset-catalog', serializedFilters],
    queryFn: ({ pageParam, signal }) =>
      fetchAssetCatalog(
        {
          ...serializedFilters,
          cursor: pageParam,
          limit: ASSET_CATALOG_PAGE_SIZE,
        },
        { signal },
      ),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
    // The route loader owns cold catalog failures. Observer errors stay local so a failed sibling
    // filter key cannot replace the rows retained by the mounted view.
    throwOnError: false,
    staleTime: ASSETS_STALE_TIME,
  });
}

export function useAssetCatalog(filters: AssetCatalogFilters = {}) {
  return useInfiniteQuery(assetCatalogQuery(filters));
}
